// client/src/locales/nl`

const nl = {
  translation: {
    navigation: {
      suggestion_title: "Misschien ook interessant voor jou:"
    },
    searchbar: {
      label: "Waar ben je naar op zoek?",
      placeholder: "bijvoorbeeld: hypotheekrente"
    },
    footer: {
      links: {
        privacy: "Privacy",
        cookie_statement: "Cookieverklaring",
        disclaimer: "Disclaimer"
      }
    },
    404: {
      title: "Pagina niet gevonden",
      description:
        "Wij hebben de door u opgevraagde pagina helaas niet kunnen vinden.",
      link: "/",
      homepage: "Naar homepage"
    },
    cookiebar: {
      title: "Welkom!",
      description:
        "Hypotrust plaatst cookies om de website gebruiksvriendelijker te maken. Je kunt kiezen uit onderstaande opties:",
      accept: "Akkoord",
      complete: {
        title: "Compleet",
        description:
          "Met behulp van deze cookies verbeteren we de website, maken we een koppeling met social media, kun je video's bekijken en een adviseur zoeken."
      },
      limited: {
        title: "Beperkt",
        description:
          "Met deze cookies kun je een adviseur zoeken, video's bekijken en kunnen wij de website verbeteren."
      },
      functional: {
        title: "Noodzakelijk",
        description:
          "Je kunt geen video's bekijken en geen adviseur zoeken. We plaatsen alleen de cookies die noodzakelijk zijn voor het functioneren van de website."
      },
      decline: "Nee",
      statement: "Cookieverklaring",
      missing:
        "Je cookies moeten ingeschakeld zijn om deze video te bekijken. Accepteer de cookies om verder te gaan."
    },
    searchResults: {
      title: 'Waar ben je naar op zoek?',
      formLabel: 'Jouw zoekopdracht',
      placeholder: 'Bijvoorbeeld: hypotheekrente',
      types: {
        page: 'Pagina',
        update: 'Update',
        form: 'Formulier',
        faq: 'Veelgestelde vraag'
      }
    },
    pagination: {
      previous: "Vorige",
      next: "Volgende"
    }
  }
};

export default nl;



// WEBPACK FOOTER //
// ./Client/locales/nl.ts